import { InputEditor } from "./InputEditor";
import { List } from "../List";
import { IListItem } from "../types";

export function getEditor(item: IListItem, list: List) {
	return new InputEditor(item, list);
}
